// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2J0qz","label":"Category_label__2CQ4l","content":"Category_content__1rXa-","header":"Category_header__2z6Lg","location":"Category_location__2162h"};